import _defineProperty from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties";
const _excluded = ["src", "alt", "initials", "variant", "cors", "delayMs"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { styled } from '@linaria/react';
import Image from 'next/image';
import { Root, Fallback } from '@radix-ui/react-avatar';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const BorderRadii = {
  round: '100%',
  rounded: '25%',
  square: '0%'
};
export const StyledAvatar = /*#__PURE__*/styled(Root)({
  name: "StyledAvatar",
  class: "s1det9gv",
  vars: {
    "s1det9gv-0": [props => props.size || '2.24rem'],
    "s1det9gv-2": [props => props.margin || '0'],
    "s1det9gv-3": [props => BorderRadii[props.variant || 'round'] || '100%']
  }
});
export const StyledAvatarImage = /*#__PURE__*/styled("div")({
  name: "StyledAvatarImage",
  class: "sxetcyi"
});
export const StyledFallback = /*#__PURE__*/styled(Fallback)({
  name: "StyledFallback",
  class: "s1bl9p93"
});
export const Avatar = _ref => {
  let {
    src,
    alt,
    initials = '',
    variant = 'round',
    cors = false,
    delayMs = 600
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_jsxs(StyledAvatar, _objectSpread(_objectSpread({}, props), {}, {
    variant: variant,
    children: [/*#__PURE__*/_jsx(StyledFallback, {
      children: initials.slice(0, 2)
    }), /*#__PURE__*/_jsx(StyledAvatarImage, {
      children: cors === true ? /*#__PURE__*/_jsx("img", {
        src: src,
        alt: alt,
        width: "64",
        height: "64"
      }) : /*#__PURE__*/_jsx(Image, {
        src: src,
        alt: alt,
        width: "64",
        height: "64"
      })
    })]
  }));
};

require("./Avatar.linaria.module.css!=!../../../../node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js!./Avatar.tsx");